import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import TabNav from "../TabNav";
import GrownUpReview from "./GrownUpReview";
import ChildReviews from "./ChildReviews";
import StarRating from "wonderbly-components/lib/StarRating";
import Button from "wonderbly-components/lib/Button";
import RichText from "../Prismic/RichText";
import { Row } from "src/client/js/view/components/Grid";
import "./ProductReviewList.scss";

const size = {
  "80%": "4-5",
  "75%": "3-4",
};

const ProductReviewList = (props) => (
  <section className="product-review-list" id={props.id}>
    <div className="container-guttered">
      <Row>
        <div
          className={cx("col", {
            [`col-${size[props.size]}`]: size[props.size],
          })}
        >
          <h3 className="text-giga product-review-title">
            {props.product.reviewList.title}
          </h3>
          <div className="overall-reviews">
            <RichText className="total" fields={props.trustPilotScore} />
            <StarRating stars={props.product.reviewList.starRating} />
          </div>
          <div className="reviews">
            <div className="product-review-nav">
              <TabNav
                currentIndex={props.currentReviewIndex}
                handleClick={props.updateReviewIndex}
                items={props.product.reviewList.body.map(
                  (section) => section.primary.tabTitle
                )}
              />
            </div>
            <div className="product-reviews">
              {props.product.reviewList.body.map((section, index) => {
                if (section.sliceType === "children_review") {
                  return (
                    <ChildReviews
                      key={section.sliceType}
                      reviews={section.items}
                      hidden={props.currentReviewIndex !== index}
                    />
                  );
                }
                return (
                  <GrownUpReview
                    key={section.sliceType}
                    reviews={section.items}
                    seeMoreLabel={section.primary.seeMoreLabel}
                    hidden={props.currentReviewIndex !== index}
                    maxCharacterLength={section.primary.maxCharacterLength}
                  />
                );
              })}
            </div>
          </div>
          {props.cta && props.handleClick && props.href && (
            <Button
              className="product-review-list-button"
              onClick={props.handleClick}
            >
              {props.cta}
            </Button>
          )}
        </div>
      </Row>
    </div>
  </section>
);

ProductReviewList.propTypes = {
  id: PropTypes.string.isRequired,
  product: PropTypes.shape({
    reviewList: PropTypes.shape({
      title: PropTypes.string,
      starRating: PropTypes.string.isRequired,
      body: PropTypes.arrayOf(
        PropTypes.shape({
          sliceType: PropTypes.string.isRequired,
          items: PropTypes.array.isRequired,
          primary: PropTypes.shape({
            tabTitle: PropTypes.string,
          }),
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
  currentReviewIndex: PropTypes.number.isRequired,
  updateReviewIndex: PropTypes.func.isRequired,
  href: PropTypes.string,
  cta: PropTypes.string,
  handleClick: PropTypes.func,
  size: PropTypes.string.isRequired,
  trustPilotScore: PropTypes.array.isRequired,
};

export default ProductReviewList;
